import { ProjectStateManagementHttpClient } from './apiClients';

export const getProjectSettingsById = async projectId => {
  const response = await ProjectStateManagementHttpClient.get({
    relativePath: `Project/${projectId}/projectsettings`
  });

  return response.data;
};
